import { render } from "./Usuarios.vue?vue&type=template&id=2c8fdc1c"
import script from "./Usuarios.vue?vue&type=script&lang=js"
export * from "./Usuarios.vue?vue&type=script&lang=js"

import "./Usuarios.vue?vue&type=style&index=0&id=2c8fdc1c&lang=css"
script.render = render

export default script